import { makeStyles } from '@fluentui/react-components';

export const useContainerActionBarStyles = makeStyles({
    createButton: {
        border: '1px solid black',
        borderRadius: 'unset',
        backgroundColor: 'rgb(242 241 238) !important',
        fontSize: '14px',
        height: '42px',
        color: 'black !important',
        '&:disabled': {
            backgroundColor: 'rgb(200, 200, 200) !important',
        },
    },
});
